import {Status} from '../../../../helpers/merge-box-status-calculator/stacks-merge-conflicts-and-rebase-section-status'
import type {StacksMergeConflictsAndRebaseSectionProps} from '../types'
import {RebaseStackButton} from './shared/RebaseStackButton'
import {useId} from 'react'

import {AlertIcon} from '../../common/AlertIcon'
import {MergeBoxSectionHeader} from '../../common/MergeBoxSectionHeader'

/**
 * Scenario: branches in the stack have diverged and must be rebased to restore a linear history.
 */
export function RequiredRebase({
  status,
  stackEntries,
  stackMetadata,
  canRebase,
  stackBaseRefRequiresSignatures,
}: StacksMergeConflictsAndRebaseSectionProps) {
  const headerId = useId()

  if (status !== Status.StackRebaseRequired) return null

  return (
    <section aria-label="Required stack rebase" className="border-bottom borderColor-muted" aria-describedby={headerId}>
      <div className="d-flex flex-column width-full overflow-hidden">
        <MergeBoxSectionHeader
          headerId={headerId}
          icon={<AlertIcon />}
          title="Some branches in this stack have diverged and must be rebased"
          subtitle="Rebase this stack to restore a linear commit history across its branches."
          rightSideContent={
            <RebaseStackButton
              stackEntries={stackEntries}
              stackMetadata={stackMetadata}
              canRebase={canRebase}
              stackBaseRefRequiresSignatures={stackBaseRefRequiresSignatures}
            />
          }
        />
      </div>
    </section>
  )
}
